

// Header.js
import React, { useEffect, useMemo, useState } from "react";
import {
    Box,
    Button,
    Typography,
    Menu,
    MenuItem,
    useMediaQuery,
    Popover,
    Paper,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import {logout } from '../../store/slices/authSlice';
import WhatsAppIcon from '../../images/whatsapp-svgrepo-com.svg';

import styles from "./styles.module.css";
import lionlogo from "../../images/lionlogo.svg";
import LoginScreen from "../LoginScreen/LoginScreen";
import user_icon from "../../images/user_icon.svg";
import MEWIN_new_logo from "../../images/MEWIN_new_logo.svg";
import EditStack from "../EditStack/EditStack"; 
import { api } from "../../api/client";
import { fetchmarket, fetchProfile ,resetProfile  } from "../../store/slices/profileSlice";
import { changePassword } from "../../store/slices/authSlice";
import useProfileSocket from "../../api/userprofilesocket";
import { GetEditStake } from "../../store/slices/sportsSlice";
import PasswordConfirmDialog from '../../components/PasswordConfirmDialog';
import SupportChatWidget from '../chat/SupportChatWidget'


const menuArray = [
    { label: "Account Statement", path: '/AccountStatement' },
    { label: "Profit & Loss", path: "/ProfitandLoss" },
    { label: "Bet History", path: "/BetHistoryTab" },
     { label: "Casino Bet History", path: "/CasinoBetHistoryTab" },
    { label: "Edit Stake", path: "/Edit-Stack" }, 
    { label: "Change Password", path: "/change-password" },
    { label: "Rules", path: "/rules" },
];




const matchData = {
    eventType: "Cricket",
    eventName: "Nepal v Italy",
    matchName: "Bookmaker",
    trade: "1",
    matchOdds: {
        max: "2L",
        team: "Nepal",
        score: "ITA Needed 98 runs from 104 balls",
        overs: "26-0 (2.4)CRR 9.75 RR 5.65"
    },
    betting: {
        back: "6.2",
        lay: "6.4",
        cashout: "7.2",
        matchedBet: "7.4",
        odds: "43",
        stake: "1000"
    }
};


const Header = () => {
    const navigate = useNavigate();
    const isDesktopView = useMediaQuery('(min-width:1023px)');
    const dispatch = useDispatch();
    const isLoggedIn = useSelector((s) => s.auth.authenticated);
    const [anchorEl, setAnchorEl] = useState(null);
    const [showLogin, setShowLogin] = useState(false);
    const [showEditStack, setShowEditStack] = useState(false);
    const bets = useSelector(state => state.match.getuserbetsdata);
    const [expPopoverAnchor, setExpPopoverAnchor] = useState(null); 
    const [showBankDetail, setShowBankDetail] = useState(false);
      const [passwordDialogOpen, setPasswordDialogOpen] = useState(false);
      const [withdrawAnchor, setWithdrawAnchor] = useState(null);
    const userId = useSelector((state) => state.auth.userId);
    const  mymarket =useSelector((state)=>state.profile.fetchmarketData);
   const { profileData: socketProfile } = useProfileSocket(userId);
    const [showSupport, setShowSupport] = useState(false);

useEffect(() => {
    if (!userId) return;
    dispatch(fetchmarket(userId));
    dispatch(fetchProfile(userId)); 
}, [dispatch, userId]);

    const handleMenuClick = (event) => setAnchorEl(event.currentTarget);
    const handleMenuClose = () => setAnchorEl(null);
// Header.js handleLogout
const handleLogout = () => {
    dispatch(logout());
    dispatch(resetProfile());
    localStorage.removeItem('userData_cache');
    handleMenuClose();
    navigate('/login');
};
      const handleLoginClick = () => {
        window.dispatchEvent(new CustomEvent('openLoginModal'));
    };

    const handleLoginSuccess = () => { };

    const handleEditStackOpen = () => {
        setShowEditStack(true);
        handleMenuClose();
    };

    const handleEditStackClose = () => {
        setShowEditStack(false);
    };
    const handleEditStakeUpdate = () => {
    if (userId) {
        dispatch(GetEditStake({ userId, GAME: 'GAME' }));
    }
};

    const handleExpClick = (event) => {
        setExpPopoverAnchor(event.currentTarget);
    };

    const handleExpClose = () => {
        setExpPopoverAnchor(null);
    };

    const handleMatchNameClick = () => {
        navigate('/cricket-bet');
        handleExpClose();
    };

    const profileData = useSelector((state) => state.profile.data);
    const profileLoading = useSelector((state) => state.profile.loading);
    const profileError = useSelector((state) => state.profile.error);


const [balanceReady, setBalanceReady] = useState(false);

useEffect(() => {
    if (!userId) return;
    dispatch(fetchProfile(userId)).then(() => setBalanceReady(true));
}, [dispatch, userId]);

const [userData, setUserData] = useState(() => {
    try {
        const cached = localStorage.getItem('userData_cache');
        return cached ? JSON.parse(cached) : { name: null, balance: null, expBalance: null };
    } catch {
        return { name: null, balance: null, expBalance: null };
    }
});

useEffect(() => {    if (!profileData && !socketProfile) return;
    const balance = socketProfile?.balance;
    const exp = socketProfile?.exp;
    const name = profileData?.username;

    if (balance === undefined || exp === undefined) return;

    const updated = {
        name: name ?? null,
        balance: `₹${Number(balance).toFixed(2)}`,
        expBalance: `₹${Number(exp).toFixed(2)}`,
    };

    setUserData(updated);
    localStorage.setItem('userData_cache', JSON.stringify(updated));
}, [profileData, socketProfile]);

    const handleBankDetailOpen = () => {
        navigate('/withdraw');
        handleMenuClose();
    };

    const handlePasswordConfirm = (password) => {
    setPasswordDialogOpen(false);
    handleBankDetailOpen();
      setWithdrawAnchor(null);
};

    const handledepositOpen = () => {
        navigate('/deposit');
        handleMenuClose();
    };

    const handleBankDetailClose = () => {
        setShowBankDetail(false);
    };

    const handleBankDetailSubmit = (bankData) => {
        console.log("Bank Details Submitted:", bankData);
        alert("Bank details saved successfully!");
    };

useEffect(() => {
    if (!userId) return;
    const handleRefresh = () => {
        dispatch(fetchProfile(userId));
    }
    window.addEventListener('focus', handleRefresh);
    document.addEventListener('visibilitychange', () => {
        if (!document.hidden) handleRefresh();
    });
    return () => {
        window.removeEventListener('focus', handleRefresh);
        document.removeEventListener('visibilitychange', handleRefresh);
    };
}, [userId]);
  

    return (
        <>
            <Box className={styles.Main_Container}>
                <Box className={styles.header}>
                    <Box className={styles.header_inner}>
                      <Box
  onClick={() => {
    console.log("clicked");
    navigate("/");
  }}
  sx={{ cursor: "pointer", position: "relative" }}
>
                            <img src={MEWIN_new_logo} className={styles.header_logo} alt="MEWIN_new_logo" />
                        </Box>

                    

                        <Box>
                            {!isLoggedIn ? (
                                <Button className={styles.logIn_btn} onClick={handleLoginClick}>
                                    <Typography className={styles.logIn_btn_txt}>Login</Typography>
                                </Button>
                            ) : (
                                <>
                                    {isDesktopView ? (
                                        <Box className={styles.user_box_containerWEB}>
                                            <Box className={styles.balance_txt_containerWEB}>
                                                <Box className={styles.walletAmt_container}>

                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="18"
                                                        height="18"
                                                        viewBox="0 0 12 12"
                                                        fill="none"
                                                    >
                                                        <path
                                                            d="M5.08203 2.51846C5.08203 1.97998 5.52012 1.54189 6.05859 1.54189H6.39656L6.29461 1.2585C6.23729 1.09912 6.08709 1 5.92701 1C5.88266 1 5.83754 1.00762 5.79344 1.02367L2.37834 2.26666C2.17531 2.34057 2.07082 2.56523 2.14516 2.76811L2.32561 3.26064H5.08203V2.51846Z"
                                                            fill="white"
                                                        />
                                                        <path
                                                            d="M6.05859 2.12783C5.84285 2.12783 5.66797 2.30271 5.66797 2.51846V3.26064H9.08594V2.51846C9.08594 2.30271 8.91105 2.12783 8.69531 2.12783H6.05859Z"
                                                            fill="white"
                                                        />
                                                        <path
                                                            d="M10.1211 8.89541H8.75391C7.94619 8.89541 7.28906 8.23828 7.28906 7.43057C7.28906 6.62285 7.94619 5.96572 8.75391 5.96572H10.1211V4.62783C10.1211 4.19637 9.77131 3.84658 9.33984 3.84658H1.78125C1.34979 3.84658 1 4.19637 1 4.62783V10.2188C1 10.6502 1.34979 11 1.78125 11H9.33984C9.77131 11 10.1211 10.6502 10.1211 10.2188V8.89541Z"
                                                            fill="white"
                                                        />
                                                        <path
                                                            d="M10.707 6.55166H8.75391C8.26928 6.55166 7.875 6.94594 7.875 7.43057C7.875 7.91519 8.26928 8.30947 8.75391 8.30947H10.707C10.8686 8.30947 11 8.17805 11 8.0165V6.84463C11 6.68309 10.8686 6.55166 10.707 6.55166ZM8.75391 7.72354C8.59211 7.72354 8.46094 7.59236 8.46094 7.43057C8.46094 7.26877 8.59211 7.1376 8.75391 7.1376C8.9157 7.1376 9.04688 7.26877 9.04688 7.43057C9.04688 7.59236 8.9157 7.72354 8.75391 7.72354Z"
                                                            fill="white"
                                                        />
                                                    </svg>

                                                    <Typography className={styles.balance_txtWEB}>
                                                        {userData.balance}
                                                    </Typography>
                                                </Box>
                                                <Typography className={styles.vertical_lineWEB}></Typography>
                                                <Typography
                                                    className={styles.expBalance_txtWEB}
                                                    onClick={handleExpClick}
                                                    
                                                >
                                                    Exp.{userData.expBalance}
                                                </Typography>


                                                <Typography className={styles.vertical_lineWEB}></Typography>
                                                <Typography className={styles.userGmail_txt}>
                                                    {userData.name}
                                                </Typography>
                                                <Box >
                                            <img className= {styles.user_icon}
                                                src={user_icon}
                                                alt="user_icon"
                                                onClick={handleMenuClick}
                                            />
                                            </Box>
                                                <Menu
                                                    anchorEl={anchorEl}
                                                    open={Boolean(anchorEl)}
                                                    onClose={handleMenuClose}
                                                    PaperProps={{
                                                        className: styles.Menu_container,
                                                    }}
                                                >
                                                    <Box className={styles.fullNameBox_container}>
                                                        <Typography className={styles.Menu_fullName}>
                                                            {userData.name}
                                                        </Typography>
                                                    </Box>

                                                    <Box>
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="229"
                                                            height="2"
                                                            viewBox="0 0 229 2"
                                                            fill="none"
                                                        >
                                                            <path
                                                                d="M1 1H228"
                                                                stroke="#DADADA"
                                                                stroke-width="0.5"
                                                                stroke-linecap="round"
                                                            />
                                                        </svg>
                                                    </Box>
                                                    {menuArray.map((item) => (
                                                        <MenuItem
                                                            className={styles.MenuItem_box}
                                                            key={item.label}
                                                            onClick={() => {
                                                                if (item.label === "Edit Stake") {
                                                                    handleEditStackOpen();
                                                                } else {
                                                                    navigate(item.path);
                                                                    handleMenuClose();
                                                                }
                                                            }}
                                                        >
                                                            <Typography className={styles.MenuItem_txt}>
                                                                {item.label}
                                                            </Typography>
                                                        </MenuItem>
                                                    ))}

                                    <MenuItem
                                                        className={styles.MenuItem_box}
                                                        onClick={handleLogout}
                                                    >
                                                        <Typography className={styles.SignOut_txt}>
                                                            Sign Out
                                                        </Typography>
                                                    </MenuItem>
 {/* ✅ 24/7 SUPPORT STRIP - desktop */}
                                            {/* ✅ 24/7 SUPPORT STRIP - desktop */}
<MenuItem
    disableRipple
    onClick={() => {
        window.open('https://wa.link/mewin01', '_blank', 'noopener,noreferrer');
        handleMenuClose();
    }}
    sx={{
        backgroundColor: '#16a34a',
        margin: '6px 8px',
        borderRadius: '6px',
        justifyContent: 'flex-start',
        gap: '8px',
        '&:hover': { backgroundColor: '#15803d' },
    }}
>
    <img src={WhatsAppIcon} alt="WhatsApp" style={{ width: '18px', height: '18px' }} />
    <Typography sx={{ color: '#ffffff', fontWeight: 800, fontSize: '13px', textAlign: 'left' }}>
        24/7 Customer Support
    </Typography>
</MenuItem>

                                                </Menu>
                                            </Box>
                                        </Box>
                                    ) : (
                                        <Box className={styles.user_box_container}>
                                            <Box className={styles.balance_txt_container}>
                                                <Box className={styles.walletAmt_container}>

                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="12"
                                                        height="12"
                                                        viewBox="0 0 12 12"
                                                        fill="none"
                                                    >
                                                        <path
                                                            d="M5.08203 2.51846C5.08203 1.97998 5.52012 1.54189 6.05859 1.54189H6.39656L6.29461 1.2585C6.23729 1.09912 6.08709 1 5.92701 1C5.88266 1 5.83754 1.00762 5.79344 1.02367L2.37834 2.26666C2.17531 2.34057 2.07082 2.56523 2.14516 2.76811L2.32561 3.26064H5.08203V2.51846Z"
                                                            fill="white"
                                                        />
                                                        <path
                                                            d="M6.05859 2.12783C5.84285 2.12783 5.66797 2.30271 5.66797 2.51846V3.26064H9.08594V2.51846C9.08594 2.30271 8.91105 2.12783 8.69531 2.12783H6.05859Z"
                                                            fill="white"
                                                        />
                                                        <path
                                                            d="M10.1211 8.89541H8.75391C7.94619 8.89541 7.28906 8.23828 7.28906 7.43057C7.28906 6.62285 7.94619 5.96572 8.75391 5.96572H10.1211V4.62783C10.1211 4.19637 9.77131 3.84658 9.33984 3.84658H1.78125C1.34979 3.84658 1 4.19637 1 4.62783V10.2188C1 10.6502 1.34979 11 1.78125 11H9.33984C9.77131 11 10.1211 10.6502 10.1211 10.2188V8.89541Z"
                                                            fill="white"
                                                        />
                                                        <path
                                                            d="M10.707 6.55166H8.75391C8.26928 6.55166 7.875 6.94594 7.875 7.43057C7.875 7.91519 8.26928 8.30947 8.75391 8.30947H10.707C10.8686 8.30947 11 8.17805 11 8.0165V6.84463C11 6.68309 10.8686 6.55166 10.707 6.55166ZM8.75391 7.72354C8.59211 7.72354 8.46094 7.59236 8.46094 7.43057C8.46094 7.26877 8.59211 7.1376 8.75391 7.1376C8.9157 7.1376 9.04688 7.26877 9.04688 7.43057C9.04688 7.59236 8.9157 7.72354 8.75391 7.72354Z"
                                                            fill="white"
                                                        />
                                                    </svg>

                                                    <Typography className={styles.balance_txt}>
                                                        {userData.balance}

                                                    </Typography>
                                                </Box>
                                                <Typography
                                                    className={styles.expBalance_txt}
                                                    onClick={handleExpClick}
                                                >
                                                    Exp. {userData.expBalance}
                                                </Typography>
                                            </Box>
                                            <Box >
                                            <img className= {styles.user_icon}
                                                src={user_icon}
                                                alt="user_icon"
                                                onClick={handleMenuClick}
                                            />
                                            </Box>
                                            <Menu
                                                anchorEl={anchorEl}
                                                open={Boolean(anchorEl)}
                                                onClose={handleMenuClose}
                                                PaperProps={{
                                                    className: styles.Menu_container,
                                                }}
                                            >
                                                <Box className={styles.fullNameBox_container}>
                                                    <Typography className={styles.Menu_fullName}>
                                                        {userData.name}
                                                    </Typography>
                                                </Box>
                                                <Box>
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="229"
                                                        height="2"
                                                        viewBox="0 0 229 2"
                                                        fill="none"
                                                    >
                                                        <path
                                                            d="M1 1H228"
                                                            stroke="#DADADA"
                                                            stroke-width="0.5"
                                                            stroke-linecap="round"
                                                        />
                                                    </svg>
                                                </Box>
                                                {menuArray.map((item) => (
                                                    <MenuItem
                                                        className={styles.MenuItem_box}
                                                        key={item.label}
                                                        onClick={() => {
                                                            if (item.label === "Edit Stake") {
                                                                handleEditStackOpen();
                                                            } else {
                                                                navigate(item.path);
                                                                handleMenuClose();
                                                            }
                                                        }}
                                                    >
                                                        <Typography className={styles.MenuItem_txt}>
                                                            {item.label}
                                                        </Typography>
                                                    </MenuItem>
                                                ))}

                                           <MenuItem
                                                    className={styles.MenuItem_box}
                                                    onClick={handleLogout}
                                                >
                                                    <Typography className={styles.SignOut_txt}>
                                                        Sign Out
                                                    </Typography>
                                                </MenuItem>


                                        {/* ✅ 2{/* ✅ 24/7 SUPPORT STRIP - mobile */}
<MenuItem
    disableRipple
    onClick={() => {
        window.open('https://wa.link/mewin01', '_blank', 'noopener,noreferrer');
        handleMenuClose();
    }}
    sx={{
        backgroundColor: '#16a34a',
        margin: '6px 8px',
        borderRadius: '6px',
        justifyContent: 'flex-start',
        gap: '8px',
        '&:hover': { backgroundColor: '#15803d' },
    }}
>
    <img src={WhatsAppIcon} alt="WhatsApp" style={{ width: '18px', height: '18px' }} />
    <Typography sx={{ color: '#ffffff', fontWeight: 800, fontSize: '13px', textAlign: 'left' }}>
        24/7 Customer Support
    </Typography>
</MenuItem>

                                            </Menu>
                                        </Box>
                                    )}
                                </>
                            )}
                        </Box>
                    </Box>
                </Box>
            </Box>
            {showLogin && <LoginScreen onLoginSuccess={handleLoginSuccess} />}
           {showEditStack && (
    <EditStack 
        open={showEditStack} 
        onClose={handleEditStackClose}
        onUpdate={handleEditStakeUpdate}  
    />
)}

{/* <PasswordConfirmDialog
    open={passwordDialogOpen}
    anchorEl={withdrawAnchor}
    onClose={() => { setPasswordDialogOpen(false); setWithdrawAnchor(null); }}
    onConfirm={handlePasswordConfirm}
/> */}

<SupportChatWidget
    open={showSupport}
    onClose={() => setShowSupport(false)}
/>

            <Popover
                open={Boolean(expPopoverAnchor)}
                anchorEl={expPopoverAnchor}
                onClose={handleExpClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                className={styles.expPopover}
                PaperProps={{
                    className: styles.expPopoverPaper
                }}
            >

                <Paper className={styles.expPopoverContent}>
                    <Box className={styles.expPopoverHeader}>
                        My Market
                        <Box
                            className={styles.expPopoverCloseBtn}
                            onClick={handleExpClose}
                        >
                            ✕
                        </Box>
                    </Box>

                    <TableContainer className={styles.expPopoverTableContainer}>
                        <Table size="medium" className={styles.expPopoverTable}>
                            <colgroup>
        <col style={{ width: '20%' }} />
        <col style={{ width: '42%' }} />
        <col style={{ width: '24%' }} />
        <col style={{ width: '14%' }} />
    </colgroup>
                            <TableHead>
                                <TableRow>
                                    <TableCell className={styles.expPopoverTableHeaderCell}>
                                        Event 
                                    </TableCell>
                                    <TableCell className={styles.expPopoverTableHeaderCell}>
                                        Event Name
                                    </TableCell>
                                    <TableCell className={styles.expPopoverTableHeaderCell}>
                                        Match Name
                                    </TableCell>
                                    <TableCell className={styles.expPopoverTableHeaderCell}>
                                        Trade
                                    </TableCell>
                                </TableRow>
                            </TableHead>

                           <TableBody>
  {mymarket && mymarket.length > 0 ? (
    mymarket.map((market, index) => (
      <TableRow
        hover
        key={`${market.matchId}-${market.marketType}-${index}`}
        className={styles.expPopoverTableRow}
      >
        <TableCell className={styles.expPopoverTableCell}>
          {market.sport}
        </TableCell>

        <TableCell>
          <Box
            className={styles.expPopoverMatchName}
            onClick={() => {
              navigate(`/CricketBetTab/4/${market.matchId}`);
              handleExpClose();
            }}
          >
            {market.matchName}
          </Box>
        </TableCell>

        <TableCell className={styles.expPopoverTableCell}>
          {market.marketType}
        </TableCell>

        <TableCell className={styles.expPopoverTableCell}>
          {market.trades}
        </TableCell>
      </TableRow>
    ))
  ) : (
    <TableRow>
      <TableCell colSpan={4} align="center">
        No Active Markets
      </TableCell>
    </TableRow>
  )}
</TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            </Popover>
        </>
        
    );
};

export default Header;
